<template>
  <div class="laboratory">
    <common-layout>
      <div slot="header">
        <h3>工程研究中心</h3>
      </div>
      <div slot="container">
        <div class="laboratory-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addEvent"
            style="background: #623aa2; border: none"
            >新增</el-button
          >
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll"
            >批量删除</el-button
          >
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width: 240px"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
          <label>所属技术领域:</label>
          <el-select
            style="width: 140px"
            v-model="fieldValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in fieldOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <label>科技服务:</label>
          <el-select
            style="width: 140px"
            v-model="serviceValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="laboratory-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column
              type="index"
              width="150"
              label="序号"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.$index + (current_page - 1) * per_page + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="名称" align="center" prop="name">
            </el-table-column>
            <el-table-column label="简介" align="center">
              <template slot-scope="scope">
                <span style="display: block; height: 23px; overflow: hidden">{{
                  GetTarg(scope.row.introduction)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="日期" align="center" prop="dateTime">
            </el-table-column>
            <el-table-column label="是否推荐" align="center" prop="hot">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.hot == 1" type="success" effect="plain">
                  是
                </el-tag>
                <el-tag v-else type="danger" effect="plain"> 否 </el-tag>
              </template>
            </el-table-column>
            <el-table-column width="240px" align="center" label="操作">
              <template slot-scope="scope">
                <!-- <el-button
                  size="mini"
                  type="success"
                  @click="release(scope.row, 1)"
                  v-if="scope.row.hot == 2"
                >推荐资源</el-button>
                <el-button size="mini" type="warning" @click="release(scope.row, 2)" v-else>取消推荐</el-button> -->
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size="per_page"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align: left; margin: 20px 0"
        >
        </el-pagination>
      </div>
    </common-layout>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="ruleForm" ref="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-form-item label="中心名称" prop="name">
                <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入中心名称"
                ></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="所属技术领域" prop="field">
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="ruleForm.field"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in fieldOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="级别" prop="level">
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="ruleForm.level"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in levelOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="科技服务" prop="service">
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="ruleForm.service"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="依托单位性质" prop="natural">
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="ruleForm.natural"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in option"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="logo" prop="logo">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                :http-request="HouImgFile"
              >
                <img
                  v-if="ruleForm.logo"
                  :src="imgUrl + ruleForm.logo"
                  class="img_border"
                  v-real-img="ruleForm.logo"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !ruleForm.logo }"
                ></i>
                <span class="upload_btn" v-if="!ruleForm.logo">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="ruleForm.logo">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="总实验面积(平方米)"
              class="special"
              prop="space"
            >
              <el-input
                v-model="ruleForm.space"
                placeholder="请输入总实验面积"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="仪器设备数(台/套)"
              class="special"
              prop="equipments"
            >
              <el-input
                v-model="ruleForm.equipments"
                placeholder="请输入仪器设备数"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="科研人员数"
              class="special"
              prop="techResearchNum"
            >
              <el-input
                v-model="ruleForm.techResearchNum"
                placeholder="请输入科研人员数"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="科研成果数"
              class="special"
              prop="techResearchGainNum"
            >
              <el-input
                v-model="ruleForm.techResearchGainNum"
                placeholder="请输入科研成果数"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="通讯地址" prop="detailed">
            <v-distpicker
              style="text-align: left"
              @selected="citySelected"
              :province="ruleForm.address.province.value"
              :city="ruleForm.address.city.value"
              :area="ruleForm.address.area.value"
            ></v-distpicker>
            <el-input
              style="margin-top: 10px"
              v-model="ruleForm.detailed"
              placeholder="请填写详细地址"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="实景图" style="text-align: center">
            <el-upload
              style="text-align: left"
              :action="this.uploadURL"
              list-type="picture-card"
              :file-list="fileList"
              :on-preview="pictureCardPreview1"
              :before-upload="beforeUpload1"
              :on-remove="handleRemove1"
              :http-request="HouImgFile1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="工程研究中心简介"
            prop="introduction"
            class="special"
          >
            <!-- <editor refName='introduction' :placeholder="'人才队伍与人才培养方面，科研仪器设备情况，承担项目情况，科技成果及获奖情况，专利，论文与著作，学术交流，经济效益，社会效益，对外开放服务进展情况。'" :quill-data="ruleForm.introduction" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
            <editor
              refName="introduction"
              :placeholderText="'人才队伍与人才培养方面，科研仪器设备情况，承担项目情况，科技成果及获奖情况，专利，论文与著作，学术交流，经济效益，社会效益，对外开放服务进展情况。'"
              v-model="ruleForm.introduction"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="依托单位情况介绍" prop="unit" class="special">
            <!-- <editor refName='unit' :placeholder="'请填写依托单位情况介绍'" :quill-data="ruleForm.unit" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData1"></editor> -->
            <editor
              refName="unit"
              :placeholderText="'请填写依托单位情况介绍'"
              v-model="ruleForm.unit"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item style="text-align: left" label="是否推荐" prop="hot">
              <el-switch
                v-model="ruleForm.hot"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="推荐度" prop="hotOrder">
              <!-- <el-input v-model.number="ruleForm.hotOrder" placeholder="请输入推荐度" :disabled="ruleForm.hot == 2"></el-input> -->
              <el-slider
                v-model="ruleForm.hotOrder"
                show-input
                :disabled="ruleForm.hot == 2"
              ></el-slider>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
// import editor from "../../components/yhQuillEditor";
import editor from "../../components/tinymce-editor/tinymce-editor";
export default {
  components: {
    CommonLayout,
    editor,
  },
  data() {
    var validateHoto = (rule, value, callback) => {
      if (this.ruleForm.hot == 1) {
        if (!value) {
          callback(new Error("请设置推荐度"));
        }
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      fieldValue: "",
      is_submit: true,
      serviceValue: "",
      total: 10,
      per_page: 10,
      current_page: 1,
      type: 0,
      Title: "",
      searchValue: "",
      dialogFormVisible: false,
      dialogVisible: false,
      dialogImageUrl: "",
      deleteRow: "",
      fileList: [],
      tableData: [],
      option: [
        {
          value: "001",
          label: "企业",
        },
        {
          value: "002",
          label: "高等院校",
        },
        {
          value: "003",
          label: "科研院所",
        },
      ],
      typeOptions: [
        {
          value: "001",
          label: "人口与健康",
        },
        {
          value: "002",
          label: "现代农业",
        },
        {
          value: "003",
          label: "医疗卫生",
        },
        {
          value: "004",
          label: "环境保护",
        },
        {
          value: "005",
          label: "交通城建",
        },
        {
          value: "006",
          label: "电子信息",
        },
        {
          value: "007",
          label: "新材料",
        },
        {
          value: "008",
          label: "装备制造",
        },
        {
          value: "009",
          label: "能源资源",
        },
        {
          value: "010",
          label: "综合化工",
        },
        {
          value: "011",
          label: "其他",
        },
      ],
      fieldOptions: [
        {
          value: "001",
          label: "装备制造技术",
        },
        {
          value: "002",
          label: "农业",
        },
        {
          value: "003",
          label: "生物医药",
        },
        {
          value: "004",
          label: "新材料",
        },
        {
          value: "005",
          label: "电子信息技术",
        },
        {
          value: "006",
          label: "能源与环保",
        },
        {
          value: "007",
          label: "其他",
        },
      ],
      levelOptions: [
        {
          value: "001",
          label: "省级",
        },
        {
          value: "002",
          label: "国家级",
        },
        // {
        //   value: 3,
        //   label: '试验发展'
        // },
      ],
      ruleForm: {
        name: "",
        logo: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "",
        service: [],
        field: [],
        level: [],
        natural: [],
        introduction: "",
        unit: "",
        dateTime: "",
        hot: 2,
        hotOrder: 0,
        space: "",
        equipments: "",
        techResearchNum: "",
        techResearchGainNum: "",
      },
      rules: {
        detailed: [
          {
            validator: (rule, value, callback) =>
              this.CheckAddress(rule, value, callback, this.ruleForm),
            required: true,
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入中心名称",
            trigger: "blur",
          },
        ],
        logo: [
          {
            required: true,
            message: "请上传logo",
            trigger: "blur",
          },
        ],
        service: [
          {
            required: true,
            message: "请选择科技服务",
            trigger: "change",
          },
        ],
        natural: [
          {
            required: true,
            message: "请选择依托单位性质",
            trigger: "change",
          },
        ],
        field: [
          {
            required: true,
            message: "请选择所属领域",
            trigger: "change",
          },
        ],
        introduction: [
          {
            required: true,
            message: "请输入研究中心简介",
            trigger: "blur",
          },
        ],
        unit: [
          {
            required: true,
            message: "请输入依托单位情况介绍",
            trigger: "blur",
          },
        ],
        hotOrder: [
          {
            required: true,
            validator: validateHoto,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getData("Resource_Center?all=1&page=" + this.current_page);
  },
  methods: {
    // release(row,type){
    //   let obj = {};
    //   obj.id = row.id;
    //   obj.type = 3;
    //   obj.hot = 1;
    // },
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-center/page`, params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
          this.current_page = res.data.current_page * 1;
        }
      });
    },
    //富文本
    getQuillData(val) {
      this.ruleForm.introduction = val;
    },
    getQuillData1(val) {
      this.ruleForm.unit = val;
    },
    //城市选择
    citySelected(e) {
      this.ruleForm.address = e;
    },
    //新增
    addEvent() {
      this.is_submit = true;
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.fileList = [];
      this.ruleForm = {
        name: "",
        logo: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "",
        service: [],
        field: [],
        level: [],
        natural: [],
        introduction: "",
        unit: "",
        dateTime: "",
        hot: 2,
        hotOrder: 0,
        space: "",
        equipments: "",
      };
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.http
              .request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-center/batchDelete?ids=` + this.deleteRow, "", "delete")
              .then((res) => {
                if (res.code == 0) {
                  this.getData("Resource_Center?all=1&page=1");
                  this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                  this.ResetSearch([
                    "searchValue",
                    "fieldValue",
                    "serviceValue",
                  ]);
                } else {
                  this.$message({
                    message: "失败！",
                    type: "error",
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的记录",
        });
      }
    },
    //搜索
    search() {
      this.current_page = 1;
      this.getData(
        "Resource_Center?all=1&name=" +
          this.searchValue +
          "&page=" +
          this.current_page +
          (this.fieldValue ? "&field=" + this.fieldValue : "") +
          (this.serviceValue ? "&service=" + this.serviceValue : "")
      );
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //编辑
    handleEdit(index, row) {
      this.is_submit = true;
      this.dialogFormVisible = true;
      this.Title = "编辑";
      row.detailed = row.address ? row.address.detailed : "";
      row.address = row.address
        ? row.address
        : { province: { value: "" }, city: { value: "" }, area: { value: "" } };
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.ruleForm.service = row.service?.split(",") || [];
      this.ruleForm.field = row.field?.split(",") || [];
      this.ruleForm.level = row.level?.split(",") || [];
      this.ruleForm.natural = row.natural?.split(",") || [];
      // this.ruleForm.detailed = row.address.detailed
      this.fileList = [];
      if (row.image) {
        let arr = [];
        arr = row.image?.split(",") || [];
        arr.forEach((item, index) => {
          this.fileList.push({
            name: "download.jpg",
            url: this.imgUrl + item,
            store_result: item,
            uid: new Date().getTime() + index,
          });
        });
      }
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-center/delete?id=` + row.id, "", "delete")
            .then((res) => {
              if (res.code == 0) {
                this.getData("Resource_Center?all=1&page=" + this.current_page);
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                this.ResetSearch(["searchValue", "fieldValue", "serviceValue"]);
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //翻页
    handleCurrentChange(e) {
      this.getData(
        "Resource_Center?all=1&name=" +
          this.searchValue +
          "&page=" +
          e +
          (this.fieldValue ? "&field=" + this.fieldValue : "") +
          (this.serviceValue ? "&service=" + this.serviceValue : "")
      );
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    //获取经纬度
    factory(name) {
      this.$jsonp(
        "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
          this.ruleForm.detailed +
          "&city=" +
          this.ruleForm.address.city.value +
          "&children=1&offset=20&page=1&extensions=all"
      )
        .then((json) => {
          let arr = json.pois[0].location?.split(",") || [];
          this.ruleForm.longitude = arr[0];
          this.ruleForm.latitude = arr[1];
          this.subData(name);
        })
        .catch((err) => {
          console.error("报错", err);
          this.is_submit = true;
          this.$message.error("未获取到经纬度,请查看地址是否完整");
        });
    },
    subData(name) {
      let obj = JSON.parse(JSON.stringify(this.ruleForm));
      let arr = [];
      this.fileList.forEach((item) => {
        if (item.response) {
          arr.push(item.response.data.store_result);
        } else {
          arr.push(item.store_result);
        }
      });
      obj.image = arr?.join(",") || "";
      obj.address.detailed = this.ruleForm.detailed;
      obj.field = this.ruleForm.field?.join(",") || "";
      obj.level = this.ruleForm.level?.join(",") || "";
      obj.service = this.ruleForm.service?.join(",") || "";
      obj.natural = this.ruleForm.natural?.join(",") || "";
      obj.dateTime = new Date().format("yyyy-MM-dd hh:mm:ss");
      let area = [
        {
          name: "兰州市",
          id: "001",
        },
        {
          name: "嘉峪关市",
          id: "002",
        },
        {
          name: "金昌市",
          id: "003",
        },
        {
          name: "白银市",
          id: "004",
        },
        {
          name: "天水市",
          id: "005",
        },
        {
          name: "武威市",
          id: "006",
        },
        {
          name: "张掖市",
          id: "007",
        },
        {
          name: "酒泉市",
          id: "008",
        },
        {
          name: "平凉市",
          id: "009",
        },
        {
          name: "庆阳市",
          id: "010",
        },
        {
          name: "定西市",
          id: "011",
        },
        {
          name: "陇南市",
          id: "012",
        },
        {
          name: "临夏回族自治州",
          id: "013",
        },
        {
          name: "甘南藏族自治州",
          id: "014",
        },
      ];
      area.forEach((item) => {
        if (obj.address.city.value == item.name) {
          obj.area = item.id;
        }
      });
      if (obj.hot == 2) {
        obj.hotOrder = 0;
      }
      delete obj.detailed;
      if (!this.ruleForm.id) {
        this.http
          .post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-center/create`, obj)
          .then((res) => {
            if (res.code == 0) {
              this.getData("Resource_Center?all=1&page=1");
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.ResetSearch(["searchValue", "fieldValue", "serviceValue"]);

              this.dialogFormVisible = false;
              this.$refs[name].resetFields();
              let obj1 = {
                name: obj.name,
                moudle: "工程研究中心",
                date_time: obj.dateTime,
              };
              // this.http.post("Index_Resource", obj1);
              this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/index-resource/create`, obj1);
            } else {
              this.is_submit = true;
            }
          })
          .catch((err) => {
            this.is_submit = true;
          });
      } else {
        // delete obj.id;
        this.http
          .post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-center/update`, obj)
          .then((res) => {
            if (res.code == 0) {
              this.getData("Resource_Center?all=1&page=1");
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.dialogFormVisible = false;
              this.$refs[name].resetFields();
              this.ResetSearch(["searchValue", "fieldValue", "serviceValue"]);
            } else {
              this.is_submit = true;
            }
          })
          .catch((err) => {
            this.is_submit = true;
          });
      }
    },
    //提交
    submitForm(name) {
      if (!this.is_submit) return false;
      this.is_submit = false;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.factory(name);
        } else {
          this.is_submit = true;
          return false;
        }
      });
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.ruleForm.logo = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    handlePictureCardPreview(file) {
      this.ruleForm.logo = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.ruleForm.logo = "";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //上传照片墙
    HouImgFile1(e) {
      var files = e.file;
      if (!files) return;
      this.createImage1(files, e, "HouImg");
    },
    //其他图片上传
    createImage1(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.fileList.push({
                name: file.name,
                url: this.imgUrl + res.data,
                store_result: res.data,
                uid: file.uid,
              });
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    //移除
    handleRemove1(file, fileList) {
      this.fileList = fileList;
    },
    //上传前
    beforeUpload1(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    //查看
    pictureCardPreview1(file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scope>
.laboratory {
  height: 100%;
  width: 100%;

  .laboratory-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .el-select {
      margin: 0 15px;

      .el-input {
        margin: 0;
      }
    }

    /deep/.el-input--suffix {
      width: 100%;
    }

    .el-input {
      // width: 400px;
      margin: 0 15px;
    }

    .date-picker {
      margin: 0 15px;

      .el-range-separator {
        width: auto;
      }
    }
  }

  .laboratory-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }

  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 198px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
}
</style>
